<template>
  <div class="button-group">
    <slot />
  </div>
</template>

<style>
.button-group {
  button {
    @apply rounded-none p-[1px];

    span {
      @apply rounded-none;
    }
  }

  > button:first-child,
  > :first-child button {
    @apply rounded-l-lg;

    span {
      @apply rounded-l-lg;
    }
  }

  > button:last-child,
  > :last-child button {
    @apply rounded-r-lg;

    span {
      @apply rounded-r-lg;
    }
  }

  > button:not(:first-child),
  > :not(:first-child) button {
    @apply ml-[-1px];
  }
}
</style>
